import React from 'react';
import './style.scss';

export const TableHeader = ({ columnData }) => (
  <thead>
    <tr>
      {columnData.map((item, i) => (
        <th key={`${i}${item}`}>
          <abbr title={item}>{item}</abbr>
        </th>
      ))}
    </tr>
  </thead>
);

export default TableHeader;
